import networkService from '../../Network/NetworkManager';
const APPURL = require('../../Constants/URLConstants');

export const getDigitalProduct = async ({listingId}) => {
  const responseJson = await networkService.networkCall(
    APPURL.URLPaths.listingsModerate + `/${listingId}/digital_contents`,
    'GET',
    '',
  );
  if (responseJson['status'] == true) {
    return responseJson['data']['digital_contents'][0];
  } else {
    return null;
  }
};
